<template>
  <v-card
    class="tank-chart pa-2"
  >
    <v-container
      style="background:#fff; height:100%"
    >
      <div
        v-if="tankChartLoader"
        class="loader-container"
      >
        <v-progress-circular
          indeterminate
          color="green"
          width="2"
          size="30"
        />
      </div>
      <TankChart
        v-else
        :legend="false"
        :customer="{...customer, areaName}"
        :tank="tank"
        :records="records"
        expand
      />
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import TankChart from '@/components/charts/TankChart.vue'
export default {
  name: 'DeliveryTankChart',
  components: {
    TankChart
  },
  props: {
    customer: {
      type: Object,
      default: () => {}
    },
    tank: {
      type: Object,
      default: () => {}
    },
    records: {
      type: Array,
      default: () => []
    },
    tankChartLoader: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    ...mapGetters('list', ['areaName'])
  }
}
</script>

<style lang="scss" scoped>
.loader-container{
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
}
.tank-chart{
  position: absolute;
  left: -312px;
  width: 320px;
  height: 320px;
  bottom: 0;
  z-index: 10;
  background: radial-gradient(var(--metal-blue), transparent);
}
</style>
